const ctaTel = document.querySelector('.cta-tel')

if (ctaTel) {
  ctaTel.addEventListener('focus', (e) => {
    setTimeout(() => {
      ctaTel.classList.add('open')
    }, 100)
  })
  ctaTel.addEventListener('blur', (e) => {
    ctaTel.classList.remove('open')
  })
  ctaTel.addEventListener('click', (e) => {
    if (
      document.activeElement === ctaTel &&
      ctaTel.classList.contains('open')
    ) {
      ctaTel.blur()
    }
  })
}
